import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';

export const selectSelectedContentContext = (state: RootState) =>
  state.contentContext.selectedContentContext;

export const selectIsContentContextModalOpen = (state: RootState) =>
  state.contentContext.isModalOpen;

export const selectIsContentContextModalOpenedForAdd = (state: RootState) =>
  state.contentContext.isModalOpenedForAdd;

export const selectFormHasErrors = createSelector(
  (state: RootState) => state.contentContext.validationErrors,
  (validationErrors) =>
    validationErrors
      ? Object.keys(validationErrors).some(
          (field) => validationErrors[field].length > 0
        )
      : false
);

export const selectValidationErrors = (state: RootState) =>
  state.contentContext.validationErrors;

export const selectFieldErrors = (field: string) =>
  createSelector(
    [selectValidationErrors],
    (validationErrors) => validationErrors[field] || []
  );
